import { ReactElement } from "react";
import { IIconProps } from "../types";

export default function IconCross({ color, size }: IIconProps): ReactElement {
  return (
    <svg
      height={size || 12}
      width={size || 12}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.998015 1.00628C1.3287 0.664572 1.86485 0.664572 2.19554 1.00628L6 4.93755L9.80445 1.00628C10.1352 0.664572 10.6713 0.664572 11.002 1.00628C11.3327 1.34799 11.3327 1.90201 11.002 2.24372L7.36688 6L11.002 9.7563C11.3327 10.098 11.3327 10.652 11.002 10.9937C10.6713 11.3354 10.1352 11.3354 9.80445 10.9937L6 7.06245L2.19554 10.9937C1.86485 11.3354 1.3287 11.3354 0.998015 10.9937C0.667328 10.652 0.667328 10.098 0.998015 9.7563L4.63313 6L0.998015 2.24372C0.667328 1.90201 0.667328 1.34799 0.998015 1.00628Z"
        fill={color || "#434856"}
      />
    </svg>
  );
}
